import { render, staticRenderFns } from "./ph-category.vue?vue&type=template&id=22be6d26&scoped=true"
import script from "./ph-category.vue?vue&type=script&lang=js"
export * from "./ph-category.vue?vue&type=script&lang=js"
import style0 from "./ph-category.vue?vue&type=style&index=0&id=22be6d26&prod&lang=css"
import style1 from "./ph-category.vue?vue&type=style&index=1&id=22be6d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22be6d26",
  null
  
)

export default component.exports